import { Injectable, } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { makeStateKey } from '@angular/platform-browser';
// rxjs
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
// models
import { AppState } from '../../booking/models/app-state.interface';
import { PassengerRuleInitialState } from '../models/copy.interface';
// path globals
import { API_PATH, SUBSCRIPTION_KEY, GET_PASSENGER_RULES_COPY_DATA } from '../globals';

@Injectable({
  providedIn: 'root',
})
export class RulesCopyService {
  private _copyRequested: boolean = false;
  public copyData$: Subject<any> = new Subject();
  private copyResponseData = null;

  constructor(
    private _appStore: Store<AppState>,
    private _http: HttpClient,
  ) { }


  getTranslationMappedByKey(jsonArray: PassengerRuleInitialState[]) {
    const jsonData = {};

    jsonArray.forEach((airline: PassengerRuleInitialState) => {
      const airlineCode = airline.airlineCode;
      jsonData[airlineCode] = {};

      // only pick booking funnel rules
      airline.booking_funnel.forEach((rule) => {
        const messageKey = rule.key || rule.en;
        delete rule.key;

        jsonData[airlineCode][messageKey] = rule;
      });
    });

    console.log("Converted object translations: " + JSON.stringify(jsonData));

    return jsonData;
  }

  getStrapiCopy(airline: string) {
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    if (this._copyRequested) { return; }
    this._copyRequested = true;
    this._http.post(API_PATH + GET_PASSENGER_RULES_COPY_DATA, {
      airlineCode: airline
    }, { headers: headers })
      .subscribe((res: any) => {
        this.copyResponseData = this.getTranslationMappedByKey(res.dynamicContent);
        this._appStore.dispatch({ type: 'RULES_COPY_LOADED', payload: true });
      });
  }

  getRulessCopy() {
    return this.copyResponseData;
  }

  getRuleByAirlineKey(arlineCode, key, isUSA) {
    if (!this.copyResponseData[arlineCode] || !this.copyResponseData[arlineCode][key]) {
      return key;
    }

    let dynamicKey = isUSA ? `${key}_USA` : key;

    return this.copyResponseData[arlineCode][dynamicKey] ?? this.copyResponseData[arlineCode][key] ?? 'N/A';
  }

  getRuleByAirline(arlineCode) {
    if (!this.copyResponseData[arlineCode]) {
      return;
    }

    return this.copyResponseData[arlineCode];
  }

}
